"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyCustomer = void 0;
function makeEmptyCustomer() {
    return {
        identifier: '',
        firstName: '',
        lastName: '',
        birthday: '',
        gender: '',
        address: '',
        email: '',
        phone: '',
        id: '',
        idType: '',
    };
}
exports.makeEmptyCustomer = makeEmptyCustomer;
//# sourceMappingURL=Customer.js.map